
































































































import Vue from "vue";
import iwModal from "@/shared/components/Modal.vue";
import { Customer } from "@/shared/interfaces/customer/Customer.interface";
import { mapState } from "vuex";
import { removeBillboardAndNotify } from "@/optimizedEncoding/scripts/helpers/billboardEligibility";

export default Vue.extend({
    components: {
        iwModal: iwModal,
    },

    props: {
        isVisible: {
            type: Boolean,
            required: true
        }
    },

    data: function() {
        return {
            selectAddressIndex: null as string | number | null,
            selectedAddressIndex: 0
        };
    },

    computed: {
        ...mapState("CustomersModule", [
            "customers",
        ]),
        customer: function(): Customer|null {
            return this.$store.getters["FormModule/getValueUI"]("customer");
        },
    },

    watch: {
        selectAddressIndex:  function(value) {
            if (value >= 0) {
                this.selectedAddressIndex = value;
            }
        },
    },

    mounted: function() {
        this.selectAddressIndex = 0;
    },

    methods: {
        closeModal: function() {
            this.$emit("closeModal");
            this.$store.commit("FormModule/addValueUI", {path: "customer.customerToEdit", value: null});
        },
        confirmSelection: function() {
            if (this.selectedAddressIndex >= 0) {
                this.$store.commit("CustomersModule/selectCurrentCustomer", this.selectedAddressIndex);
                this.$store.commit("CustomersModule/setInitialCustomer", this.customers[this.selectedAddressIndex]);
                removeBillboardAndNotify();
                this.closeModal();
            }
        },
        openNewCustomerModal: function() {
            this.$emit("open-new-customer-modal");
            this.$store.commit("FormModule/addValueUI", {path: "customer.customerToEdit", value: null});
        },
        openEditCustomerModal: function(customer: Customer) {
            this.$emit("open-new-customer-modal");
            this.$store.commit("FormModule/addValueUI", {path: "customer.customerToEdit", value: customer});
        }
    }
});

